module.exports = __webpack_public_path__ + "static/media/wordle_classic.daca05bd.png";